import React from 'react';

// Placeholders shaped like the content they stand in for (DATA-340), so the
// page doesn't jump when the data lands. Same card style as the Dashboard
// and Pipelines skeletons.

export const SkeletonList: React.FC<{ rows?: number; label?: string }> = ({ rows = 4, label = 'Loading' }) => (
  <div className="grid gap-4" role="status" aria-label={label}>
    {Array.from({ length: rows }, (_, i) => (
      <div key={i} className="bg-surface rounded-xl shadow-sm border border-line p-5 animate-pulse">
        <div className="flex items-center justify-between">
          <div className="flex-1 space-y-2">
            <div className="h-4 w-48 bg-line rounded" />
            <div className="h-3 w-80 max-w-full bg-canvas rounded" />
          </div>
          <div className="h-7 w-20 bg-canvas rounded-lg ml-4" />
        </div>
      </div>
    ))}
  </div>
);

export const SkeletonLines: React.FC<{ rows?: number; label?: string }> = ({ rows = 3, label = 'Loading' }) => (
  <div className="space-y-2 py-4 px-4 animate-pulse" role="status" aria-label={label}>
    {Array.from({ length: rows }, (_, i) => (
      <div key={i} className="h-3 w-full bg-canvas rounded" />
    ))}
  </div>
);

/** Shown while a page's code downloads (React.lazy). */
export const PageSkeleton: React.FC = () => (
  <div>
    <div className="animate-pulse mb-6">
      <div className="h-7 w-40 bg-line rounded" />
      <div className="h-3 w-64 bg-canvas rounded mt-2" />
    </div>
    <SkeletonList rows={3} label="Loading page" />
  </div>
);
